import { DIFF_REVIEW } from "../../../../../theme/tokens";

/**
 * Fixed height of the expanded provenance panel, so the grid can size its detail row without
 * measuring it. Lives here rather than being exported from the component that renders it: the grid
 * needs the number to answer `getExpandContentHeight`, and importing a component for a constant makes
 * a layout number look like a rendering dependency.
 */
export const AIRTABLE_EVIDENCE_HEIGHT = DIFF_REVIEW.EVIDENCE_HEIGHT;
